import { AccountType } from "@/enums/account-type";
import { snakeCaseObject } from "@/helpers/object-mapper";
import { initialState } from "@/store/modules/permissions/state";
import { FacilityPermissionsEnum } from "@/enums/facility-permissions.enum";

export default {
  setCompany({ commit }, company) {
    commit("SET_COMPANY", company);
  },

  setActiveDialog({ commit }, { type, mode = null }) {
    commit("SET_MODE", mode);
    commit("SET_ACTIVE_DIALOG", type);
  },

  setAccountType({ commit }, type) {
    commit("SET_ACCOUNT_TYPE", type);
    commit("SET_ALL_FACILITIES_ACCESS", type === AccountType.ADMIN);
    commit("SET_FACILITIES_IDS", []);
    commit("SET_PERMISSIONS", { ...initialState().member.permissions });
  },

  setPermission({ state, commit }, { key, value }) {
    const permissions = {
      ...state.member.permissions,
      [key]: value
    };

    commit("SET_PERMISSIONS", permissions);
  },

  getMemberRequestBody({ state }) {
    const {
      email,
      type,
      facilitiesIds,
      facilitiesGroupsIds,
      allFacilitiesAccess,
      permissions,
      permissionType
    } = state.member;

    const body = {
      email,
      type,
      allFacilitiesAccess
    };
    if (!allFacilitiesAccess) {
      if (permissionType === FacilityPermissionsEnum.SELECTED) {
        body.facilitiesIds = facilitiesIds;
      } else if (permissionType === FacilityPermissionsEnum.SELECT_GROUPS) {
        body.facilitiesGroupsIds = facilitiesGroupsIds;
      }
    }

    if (type === AccountType.MANAGER) {
      body.permissions = permissions;
    }

    return snakeCaseObject(body);
  }
};
